/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import Loadable from 'react-loadable';
const BookATour = Loadable({
  loader: () => import(/* webpackChunkName: "BookATour" */ '../components/BookATour'),
  loading: () => <div></div>,
  modules: ['BookATour'],
  });
const BookingConfirmationDetails = Loadable({
  loader: () => import(/* webpackChunkName: "BookingConfirmationDetails" */ '../components/BookingConfirmationDetails'),
  loading: () => <div></div>,
  modules: ['BookingConfirmationDetails'],
  });
const BookingConfirmationHeroComponent = Loadable({
  loader: () => import(/* webpackChunkName: "BookingConfirmationHeroComponent" */ '../components/BookingConfirmationHeroComponent'),
  loading: () => <div></div>,
  modules: ['BookingConfirmationHeroComponent'],
  });
const ContactForm = Loadable({
  loader: () => import(/* webpackChunkName: "ContactForm" */ '../components/ContactForm'),
  loading: () => <div></div>,
  modules: ['ContactForm'],
  });
const ContactHeroBanner = Loadable({
  loader: () => import(/* webpackChunkName: "ContactHeroBanner" */ '../components/ContactHeroBanner'),
  loading: () => <div></div>,
  modules: ['ContactHeroBanner'],
  });
const CookieConsent = Loadable({
  loader: () => import(/* webpackChunkName: "CookieConsent" */ '../components/CookieConsent'),
  loading: () => <div></div>,
  modules: ['CookieConsent'],
  });
const CorporateDetail = Loadable({
  loader: () => import(/* webpackChunkName: "CorporateDetail" */ '../components/CorporateDetail'),
  loading: () => <div></div>,
  modules: ['CorporateDetail'],
  });
const DiningComponent = Loadable({
  loader: () => import(/* webpackChunkName: "DiningComponent" */ '../components/DiningComponent'),
  loading: () => <div></div>,
  modules: ['DiningComponent'],
  });
const DiningHeroComponent = Loadable({
  loader: () => import(/* webpackChunkName: "DiningHeroComponent" */ '../components/DiningHeroComponent'),
  loading: () => <div></div>,
  modules: ['DiningHeroComponent'],
  });
const ErrorPage = Loadable({
  loader: () => import(/* webpackChunkName: "ErrorPage" */ '../components/ErrorPage'),
  loading: () => <div></div>,
  modules: ['ErrorPage'],
  });
const EventsContactForm = Loadable({
  loader: () => import(/* webpackChunkName: "EventsContactForm" */ '../components/EventsContactForm'),
  loading: () => <div></div>,
  modules: ['EventsContactForm'],
  });
const ExperienceTermsAndConditions = Loadable({
  loader: () => import(/* webpackChunkName: "ExperienceTermsAndConditions" */ '../components/ExperienceTermsAndConditions'),
  loading: () => <div></div>,
  modules: ['ExperienceTermsAndConditions'],
  });
const FAQ = Loadable({
  loader: () => import(/* webpackChunkName: "FAQ" */ '../components/FAQ'),
  loading: () => <div></div>,
  modules: ['FAQ'],
  });
const Gallery = Loadable({
  loader: () => import(/* webpackChunkName: "Gallery" */ '../components/Gallery'),
  loading: () => <div></div>,
  modules: ['Gallery'],
  });
const HeroAreaComponent = Loadable({
  loader: () => import(/* webpackChunkName: "HeroAreaComponent" */ '../components/HeroAreaComponent'),
  loading: () => <div></div>,
  modules: ['HeroAreaComponent'],
  });
const HeroBannerList = Loadable({
  loader: () => import(/* webpackChunkName: "HeroBannerList" */ '../components/HeroBannerList'),
  loading: () => <div></div>,
  modules: ['HeroBannerList'],
  });
const HeroVideoComponent = Loadable({
  loader: () => import(/* webpackChunkName: "HeroVideoComponent" */ '../components/HeroVideoComponent'),
  loading: () => <div></div>,
  modules: ['HeroVideoComponent'],
  });
const Inspiration = Loadable({
  loader: () => import(/* webpackChunkName: "Inspiration" */ '../components/Inspiration'),
  loading: () => <div></div>,
  modules: ['Inspiration'],
  });
const LeftNavigation = Loadable({
  loader: () => import(/* webpackChunkName: "LeftNavigation" */ '../components/LeftNavigation'),
  loading: () => <div></div>,
  modules: ['LeftNavigation'],
  });
const MapComponent = Loadable({
  loader: () => import(/* webpackChunkName: "MapComponent" */ '../components/MapComponent'),
  loading: () => <div></div>,
  modules: ['MapComponent'],
  });
const MapComponent_Old = Loadable({
  loader: () => import(/* webpackChunkName: "MapComponent_Old" */ '../components/MapComponent_Old'),
  loading: () => <div></div>,
  modules: ['MapComponent_Old'],
  });
const OffersTnC = Loadable({
  loader: () => import(/* webpackChunkName: "OffersTnC" */ '../components/OffersTnC'),
  loading: () => <div></div>,
  modules: ['OffersTnC'],
  });
const PageFooter = Loadable({
  loader: () => import(/* webpackChunkName: "PageFooter" */ '../components/PageFooter'),
  loading: () => <div></div>,
  modules: ['PageFooter'],
  });
const PageHeader = Loadable({
  loader: () => import(/* webpackChunkName: "PageHeader" */ '../components/PageHeader'),
  loading: () => <div></div>,
  modules: ['PageHeader'],
  });
const PRDetail = Loadable({
  loader: () => import(/* webpackChunkName: "PRDetail" */ '../components/PRDetail'),
  loading: () => <div></div>,
  modules: ['PRDetail'],
  });
const PRDetailHero = Loadable({
  loader: () => import(/* webpackChunkName: "PRDetailHero" */ '../components/PRDetailHero'),
  loading: () => <div></div>,
  modules: ['PRDetailHero'],
  });
const PressCentreCarousel = Loadable({
  loader: () => import(/* webpackChunkName: "PressCentreCarousel" */ '../components/PressCentreCarousel'),
  loading: () => <div></div>,
  modules: ['PressCentreCarousel'],
  });
const PressReleases = Loadable({
  loader: () => import(/* webpackChunkName: "PressReleases" */ '../components/PressReleases'),
  loading: () => <div></div>,
  modules: ['PressReleases'],
  });
const RetrieveBooking = Loadable({
  loader: () => import(/* webpackChunkName: "RetrieveBooking" */ '../components/RetrieveBooking'),
  loading: () => <div></div>,
  modules: ['RetrieveBooking'],
  });
const SchoolContactForm = Loadable({
  loader: () => import(/* webpackChunkName: "SchoolContactForm" */ '../components/SchoolContactForm'),
  loading: () => <div></div>,
  modules: ['SchoolContactForm'],
  });
const SiteMaintenance = Loadable({
  loader: () => import(/* webpackChunkName: "SiteMaintenance" */ '../components/SiteMaintenance'),
  loading: () => <div></div>,
  modules: ['SiteMaintenance'],
  });
const Sitemap = Loadable({
  loader: () => import(/* webpackChunkName: "Sitemap" */ '../components/Sitemap'),
  loading: () => <div></div>,
  modules: ['Sitemap'],
  });
const TnCDetails = Loadable({
  loader: () => import(/* webpackChunkName: "TnCDetails" */ '../components/TnCDetails'),
  loading: () => <div></div>,
  modules: ['TnCDetails'],
  });
const TourCategoryList = Loadable({
  loader: () => import(/* webpackChunkName: "TourCategoryList" */ '../components/TourCategoryList'),
  loading: () => <div></div>,
  modules: ['TourCategoryList'],
  });
const Tripadvisor = Loadable({
  loader: () => import(/* webpackChunkName: "Tripadvisor" */ '../components/Tripadvisor'),
  loading: () => <div></div>,
  modules: ['Tripadvisor'],
  });
const ViewMyBooking = Loadable({
  loader: () => import(/* webpackChunkName: "ViewMyBooking" */ '../components/ViewMyBooking'),
  loading: () => <div></div>,
  modules: ['ViewMyBooking'],
  });
const VisitExperiences = Loadable({
  loader: () => import(/* webpackChunkName: "VisitExperiences" */ '../components/VisitExperiences'),
  loading: () => <div></div>,
  modules: ['VisitExperiences'],
  });
const VisitListComponent = Loadable({
  loader: () => import(/* webpackChunkName: "VisitListComponent" */ '../components/VisitListComponent'),
  loading: () => <div></div>,
  modules: ['VisitListComponent'],
  });

const components = new Map();
components.set('BookATour', BookATour);
components.set('BookingConfirmationDetails', BookingConfirmationDetails);
components.set('BookingConfirmationHeroComponent', BookingConfirmationHeroComponent);
components.set('ContactForm', ContactForm);
components.set('ContactHeroBanner', ContactHeroBanner);
components.set('CookieConsent', CookieConsent);
components.set('CorporateDetail', CorporateDetail);
components.set('DiningComponent', DiningComponent);
components.set('DiningHeroComponent', DiningHeroComponent);
components.set('ErrorPage', ErrorPage);
components.set('EventsContactForm', EventsContactForm);
components.set('ExperienceTermsAndConditions', ExperienceTermsAndConditions);
components.set('FAQ', FAQ);
components.set('Gallery', Gallery);
components.set('HeroAreaComponent', HeroAreaComponent);
components.set('HeroBannerList', HeroBannerList);
components.set('HeroVideoComponent', HeroVideoComponent);
components.set('Inspiration', Inspiration);
components.set('LeftNavigation', LeftNavigation);
components.set('MapComponent', MapComponent);
components.set('MapComponent_Old', MapComponent_Old);
components.set('OffersTnC', OffersTnC);
components.set('PageFooter', PageFooter);
components.set('PageHeader', PageHeader);
components.set('PRDetail', PRDetail);
components.set('PRDetailHero', PRDetailHero);
components.set('PressCentreCarousel', PressCentreCarousel);
components.set('PressReleases', PressReleases);
components.set('RetrieveBooking', RetrieveBooking);
components.set('SchoolContactForm', SchoolContactForm);
components.set('SiteMaintenance', SiteMaintenance);
components.set('Sitemap', Sitemap);
components.set('TnCDetails', TnCDetails);
components.set('TourCategoryList', TourCategoryList);
components.set('Tripadvisor', Tripadvisor);
components.set('ViewMyBooking', ViewMyBooking);
components.set('VisitExperiences', VisitExperiences);
components.set('VisitListComponent', VisitListComponent);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
